import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

const name = 'cookieConsent'

const initialState = {
  shouldLoad: false
}

const cookieConsent = createSlice({
  name,
  initialState,
  reducers: {
    SET_SHOULD_LOAD: (state, { payload }) => {
      state.shouldLoad = payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        language: action.payload[name]?.language || state.language,
        shouldLoad: action.payload[name]?.shouldLoad || state.shouldLoad
      }
    })
  }
})

export default cookieConsent

export const cookieConsentActions = cookieConsent.actions
export const cookieConsentSelectors = {
  selectShouldLoad: state => state[name]?.shouldLoad
}
